<template>
	<div class="gb-chart-content">
		<GBChartRow
			v-bind:item="item"
			v-bind:isEditable="isEditable"
			v-bind:ghost_schedule="ghost_schedule"
			v-on:hscroll-stop="onHScrollStop"
			v-on:bar-move-start="barMoveStart"
			v-on:bar-stretch-start="barStretchStart"
			v-on:bar-move-break="barMoveBreak"
			v-on:chart-row-mouse-move="onMouseMoveChartRow"
			v-on:progress-rate-setting="progressRateSetting"
			v-on:request-ghost-schedule="onRequestGhostSchedule" />
		<TransitionExpand>
			<div v-if="isExpanded">
				<GBChartRow
					v-for="child in filteringChildren"
					v-bind:key="child.code"
					v-bind:item="child"
					v-bind:parent="item"
					v-bind:isEditable="isEditable"
					v-bind:ghost_schedule="ghost_schedule"
					v-on:hscroll-stop="onHScrollStop"
					v-on:bar-move-start="barMoveStart"
					v-on:bar-stretch-start="barStretchStart"
					v-on:bar-move-break="barMoveBreak"
					v-on:chart-row-mouse-move="onMouseMoveChartRow"
					v-on:progress-rate-setting="progressRateSetting"
					v-on:request-ghost-schedule="onRequestGhostSchedule" />
			</div>
		</TransitionExpand>
	</div>
</template>
<script>
import GBChartRow from './GBChartRow';
import TransitionExpand from './TransitionExpand';
import ScheduleListRow from '../data/ScheduleListRow';

export default {
	name: 'GBChartContent',
	components: {
		GBChartRow,
		TransitionExpand,
	},
	props: [
		"item",
		"isEditable",
		"ghost_schedule",
	],
	computed: {
		isExpanded: function() {
			return this.$store.getters.isExpandedScheduleListRow(this.item);
		},
		checkParentBarType: function(){
			return this.item.item_type;
		},
		checkChildBarType: function(){
			var item_type = ScheduleListRow.ITEM_TYPE.MEMBER;
			
			if(this.item.item_type == ScheduleListRow.ITEM_TYPE.MEMBER) {
				item_type = ScheduleListRow.ITEM_TYPE.PROJECT;
			}
			return item_type;
		},
		filteringChildren: function() {
			return this.$store.getters.filteringChildlen(this.item.children, this.item.alert);
		},
	},
	methods: {
		barMoveStart: function(e) {
			this.$emit('bar-move-start', e);
		},
		barStretchStart: function(e) {
			this.$emit('bar-stretch-start', e);
		},
		barMoveBreak: function() {
			this.$emit('bar-move-break');
		},
		onMouseMoveChartRow: function(e) {
			this.$emit('chart-row-mouse-move', e);
		},
		onHScrollStop: function(e) {
			this.$emit('hscroll-stop', e);
		},
		progressRateSetting: function(e) {
			this.$emit("progress-rate-setting", e);
		},
		onRequestGhostSchedule: function(e) {
			this.$emit("request-ghost-schedule", e);
		},
	},
}
</script>
<style>
	.gb-chart-content {
		border-bottom: 2px solid #a9a9a9;
	}
</style>
